import React from "react";
import zxcvbn from "zxcvbn";
import classNames from "classnames";

import css from "./style.scss";

const colors = {
  0: "#CA1551",
  1: "#F4AC21",
  2: "#128292",
  3: "#128292",
};

const getColor = (power, index, password) => {
  if(!password) return "#DFE1E4";
  if(power >= index){
    return colors[power]
  }
  return "#DFE1E4";
};

const indicatorIndexes = [0, 1, 2, 3];


const INFO = {
  0: "Weak",
  1: "Medium",
  2: "Strong",
  3: "Very strong",
}

const Indicator = ({ password }) => {
  const [score, setScore] = React.useState(0);

  React.useEffect(()=>{
    if(!password){
      setScore(0);
      return;
    }
    const result = zxcvbn(password);
    const score = result.score;
    if(score <= 3) setScore(Math.ceil(score));
  }, [password])
  
  return (
    <div className={classNames(css.clsWrapper)}>
      {password && <p style={{ color: colors[score] }} className={classNames(css.clsInfoTitle)}>{INFO[score]}</p>}
      <div className={classNames(css.clsIndicatorContainer)}>
        {indicatorIndexes.map((indicatorIndex, index) => (
          <div
            className={classNames(css.clsIndicator)}
            key={indicatorIndex}
            style={{ backgroundColor: getColor(score, indicatorIndex, password), marginLeft:  index !== 0 ? "8px" : "0px" }}
          />
        ))}
      </div>
    </div>
   
  );
};

export default Indicator;
